// removed by extract-text-webpack-plugin
module.exports = {"templateCard":"_1vSW"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/FlowCreateModal/FlowCreateModal.scss
// module id = 1D96
// module chunks = 0